import React, { useState } from 'react';
import FreeTextAddressInput from './FreeTextAddressInput';
export function AddressInput(_ref) {
  var defaultAddress = _ref.defaultAddress,
    address = _ref.address,
    preselectAddress = _ref.preselectDefaultAddress,
    onAddressSelectChange = _ref.onAddressSelectChange,
    labelPrefix = _ref.labelPrefix,
    _ref$handleBlur = _ref.handleBlur,
    handleBlur = _ref$handleBlur === void 0 ? function () {} : _ref$handleBlur,
    confirmationText = _ref.confirmationText,
    _ref$requireConfirmat = _ref.requireConfirmation,
    requireConfirmation = _ref$requireConfirmat === void 0 ? true : _ref$requireConfirmat;
  var _useState = useState(preselectAddress),
    preselectDefaultAddress = _useState[0],
    setPreselectDefaultAddress = _useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-span-6"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, preselectDefaultAddress ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("select", {
    className: "focus:ring-ring Main focus:border-ringMain mt-2 block w-full rounded-md border border-gray-300 bg-white px-3 py-2 shadow-sm focus:outline-none sm:text-base"
  }, /*#__PURE__*/React.createElement("option", null, " ", defaultAddress)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setPreselectDefaultAddress(false);
    },
    className: "mt-2 pl-1 text-start text-xs hover:underline"
  }, "Can't find your address?")) : /*#__PURE__*/React.createElement(FreeTextAddressInput, {
    defaultValue: defaultAddress,
    onAddressSelectChange: onAddressSelectChange,
    address: address,
    handleBlur: handleBlur,
    labelPrefix: labelPrefix,
    confirmationText: confirmationText,
    requireConfirmation: requireConfirmation
  }))));
}
AddressInput.displayName = 'AddressInput';